exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".import-grid-header .rt-thead .active.dropdown {\n  min-width: 0 !important;\n  background-color: #edf3f7;\n}\n.import-grid-header .rt-thead .active.dropdown .menu {\n  min-width: 14em !important;\n  left: 0 !important;\n  max-height: 23rem !important;\n}\n.import-grid-header .rt-thead .rt-tr > div:last-child .menu.visible {\n  left: auto !important;\n  right: 0px !important;\n}\n.import-grid-header .rt-thead .rt-tr > div:last-child .rt-resizer {\n  width: 18px !important;\n  right: 0px !important;\n}\n.import-grid-header .rt-thead .rt-resizable-header {\n  overflow: visible !important;\n}\n.import-grid-header .rt-thead .rt-resizable-header-content {\n  overflow: visible !important;\n}\n.import-grid-header .rt-thead .text {\n  max-width: 100% !important;\n}\n.import-grid-header .rt-thead .skip-text {\n  color: #df4d20;\n}\n.import-grid-header {\n  top: -30px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/fileimportheadermapgrid.less
// module id = 2618
// module chunks = 0